import { useContext } from "react";
import { MediaPlayerContext } from "./media-player-context";

export function useMediaPlayer() {
  const mediaPlayer = useContext(MediaPlayerContext);
  if (!mediaPlayer) {
    throw new Error("MediaPlayer not found");
  }
  return mediaPlayer;
}
